import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { combineLatest, first, Observable, switchMap } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { select, Store } from '@ngrx/store';
import {
  UserSessionsState,
  UserSessionStoreSelectors,
} from '@booking-booster-client/root-store';
import { environment } from '../../environments/environment';
import { BYPASS_IPERSONATE_HEADER } from '@booking-booster-client/models';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    private oAuthService: OAuthService,
    private store: Store<UserSessionsState>,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const bypassImpersonateHeader = request.context.get(
      BYPASS_IPERSONATE_HEADER,
    );

    if (request.url.includes('http://') || request.url.includes('https://')) {
      return next.handle(request);
    }

    if (request.url.includes('api/')) {
      request = request.clone({
        url: environment.host + request.url,
      });

      let headers = request.headers;

      if (
        this.oAuthService.hasValidAccessToken() &&
        !headers.get('Authorization')
      ) {
        headers = headers.set(
          'Authorization',
          `Bearer ${this.oAuthService.getAccessToken()}`,
        );
        return combineLatest([
          this.store.select(
            UserSessionStoreSelectors.selectSelectedOrganizationId,
          ),
          this.store.pipe(
            select(UserSessionStoreSelectors.selectImpersonateUserId),
          ),
        ]).pipe(
          first(),
          switchMap(([organization, impersonateId]) => {
            if (organization) {
              headers = headers.set('zbb-organization-id', organization);
            }
            if (impersonateId && !bypassImpersonateHeader) {
              headers = headers.set('zbb-impersonate-id', impersonateId);
            }

            request = request.clone({ headers });
            return next.handle(request);
          }),
        );
      }
    }

    return next.handle(request);
  }
}
